
import Typography from '@mui/material/Typography';


export const TextDrugAzathioprine = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Azathioprine is used with other medications to prevent transplant rejection (attack of the transplanted organ by the immune system) 
in people who received kidney transplants. It is also used to treat severe rheumatoid arthritis 
(a condition in which the body attacks its own joints, causing pain, swelling, and loss of function) when other medications and treatments have not helped. 
Azathioprine is in a class of medications called immunosuppressants. It works by decreasing the activity of the body's immune system 
so it will not attack the transplanted organ or the joints.
<br /><br />


Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a682167.html

</Typography>

</div>

)
}